import { of as observableOf, Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Lexicon from '@app/models/lexicon';

import { LogService } from '@oa/shared-core';

/* NG6+ 
@Injectable({
  providedIn: 'root',
})
*/

/**
 * Lexicon Service
 */
@Injectable()
export class LexiconService {
  private readonly _serviceName = 'LexiconService';

  private lexicon: Lexicon;

  public beVerbForms = ['be', 'am', 'is', 'are', 'was', 'were', 'being', 'been'];

  constructor(private http: HttpClient, private log: LogService) {
    // TODO: set this when app starts instead of hard-coding an initial version
    this.lexicon = {
      lexemes: [
        {
          name: 'rental',
          variables: [
            {
              dialectArea: 'default',
              value: 'lease',
              description: 'United States, Widespread',
            },
            {
              dialectArea: 'midland',
              description: 'Midland American English - Rental',
              value: 'rental',
            },
            {
              dialectArea: 'texan',
              description: 'Texas',
              value: 'lease',
            },
          ],
        },
        {
          name: 'rentals',
          variables: [
            {
              dialectArea: 'default',
              value: 'leases',
              description: 'United States, Widespread',
            },
            {
              dialectArea: 'midland',
              description: 'Midland American English - Rental',
              value: 'rentals',
            },
            {
              dialectArea: 'texan',
              description: 'Texas',
              value: 'leases',
            },
          ],
        },
        {
          name: 'leases',
          variables: [
            {
              dialectArea: 'default',
              value: 'leases',
              description: 'United States, Widespread',
            },
            {
              dialectArea: 'midland',
              description: 'Midland American English - Rental',
              value: 'leases',
            },
            {
              dialectArea: 'texan',
              description: 'Texas',
              value: 'leases',
            },
          ],
        },
        {
          name: 'lease',
          variables: [
            {
              dialectArea: 'default',
              value: 'lease',
              description: 'United States, Widespread',
            },
            {
              dialectArea: 'midland',
              description: 'Midland American English - Rental',
              value: 'lease',
            },
            {
              dialectArea: 'texan',
              description: 'Texas',
              value: 'lease',
            },
          ],
        },
      ],
    } as Lexicon;
  }

  /**
   * Gets the Outdoor Access lexicon from the API
   */
  getLexicon(): Observable<Lexicon> {
    /* 
      this.lexicon.getLexicon().subscribe(lex =>{
      // console.log('getLexicon',lex);
      }); 
      
     */

    // console.log('LexiconService.getLexicon');

    if (this.lexicon) {
      return observableOf(this.lexicon);
    } else {
      return this.http.get<Lexicon>('lexicon').pipe(
        map((data) => {
          this.lexicon = data;
          return data;
        })
      );
    }
  }

  /**
   * Gets a lexical value for a name and dialect area
   */
  public getLexicalValue(name: string, dialectArea: string) {
    if (!this.lexicon) {
      return name;
    }

    return this.getLexicalValueFromLexicon(this.lexicon, name, dialectArea);
  }

  private getLexicalValueFromLexicon(data: Lexicon, name: string, dialectArea: string) {
    const key = name.toLowerCase();

    const lexeme = this.lexicon.lexemes.find((lex) => lex.name === key);

    if (lexeme) {
      const lexicalVariable = lexeme.variables.find((v) => v.dialectArea === dialectArea);

      if (lexicalVariable) {
        return lexicalVariable.value;
      }

      console.warn(`Could not find a lexical variable for: ${name} for dialect: ${dialectArea}`);
      return name;
    } else {
      throw new Error(`Unable to find Lexeme for: ${name}`);
    }
  }
}
